const partnerBillingTypes = Object.freeze({
    ACHPaymentToHC: 1,
    DirectFromBankAccount: 2
});
export const partnerBillingTypesNamesMap = Object.freeze({
    [partnerBillingTypes.ACHPaymentToHC]: 'ACH payment to HC',
    [partnerBillingTypes.DirectFromBankAccount]: 'Direct from Bank Account'
});
export default partnerBillingTypes;
